/**
 * Mobile Menu.
 * When an item with children is clicked,
 * swipe in the child menu
 * */

export default {
  init() {

    let childContainerClass = 'mobile-nav-menu__child-container';
    let mobileNavMenuChildSelector = '.mobile-nav-menu__child';

    // Containers for Children items.
    // Containers are loaded with content on click, and swiped in.
    // Level 2 Container for Level 2 links,  Level 3 Container for Level 3 links
    let containerLevel2 = '.mobile-nav-menu__child-container--level-2';
    let containerLevel3 = '.mobile-nav-menu__child-container--level-3';

    $('body').on('click', '.mobile-nav-menu__link', function(e) {
      if( $(this).next(mobileNavMenuChildSelector).length ) {
        e.preventDefault();

        if( $(this).parents().hasClass(childContainerClass) ) { // A Level 2 link link has been clicked
          $(containerLevel3).empty();
          // Clone child content and add it to the Level 3 container
          $(this).next(mobileNavMenuChildSelector).clone().appendTo(containerLevel3);

          $(containerLevel3).addClass(childContainerClass+'--active');

        } else { // A Level 1 link has been clicked
          $(containerLevel2).empty();
          // Clone child content and add it to the Level 2 container

          $(this).next(mobileNavMenuChildSelector).clone().appendTo(containerLevel2);

          $(containerLevel2).addClass(childContainerClass+'--active');
        }

      }
    });

    // Back Button
    // - Remove Active Class
    // - Empty Container
    $('body').on('click', '.mobile-nav-menu__back', function(e) {
      e.preventDefault();

      var $activeContainer = $(this).parents('.mobile-nav-menu__child-container--active');
      $activeContainer.removeClass('mobile-nav-menu__child-container--active');

      setTimeout(() => {
        $activeContainer.empty();
      }, 500);
    });

    // Open Menu
    $('[data-open-menu]').on('click', function() {
      $(this).toggleClass('is-active');
      $('.mobile-nav-menu').toggleClass('mobile-nav-menu--active', $(this).hasClass('is-active'));
      $('body').toggleClass('mobile-menu-active', $(this).hasClass('is-active'));
      $('.mobile-nav-menu__child-container--active').removeClass('mobile-nav-menu__child-container--active'); // reset menu
    });

    // close menu on window re-size (if open)
    $(window).on('resize', function() {
      if( $('.header__nav').hasClass('mobile-nav-menu--active') && !$('.header__burger').is(':visible')) {
        $('[data-open-menu]').trigger('click');
      }
    });
  },

}



// WEBPACK FOOTER //
// ./scripts/lib/mobile-menu.js